<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    top="5vh"
    show-close
    width="95%"
    :title="$l('dialog_title_batchEdit') || '确认产品补货数量'"
    :close-on-click-modal="false"
    :before-close="() => $refs.main.cancel()"
    :modal-append-to-body="false"
    :modal="false"
    v-el-dialog-drag
  >
    <Main
      ref="main"
      @close="close"
      @update-success="afterOpenIsUpdate = true"
      :amzReplenishmentCode="amzReplenishmentCode"
    >
    </Main>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    amzReplenishmentCode: { type: String, default: '' },
  },
  data() {
    return {
      // 用户打开弹框后是否有修改数据
      afterOpenIsUpdate: false,
    }
  },
  methods: {
    close() {
      if (this.afterOpenIsUpdate) {
        this.$emit('reload')
      }
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
